export default {
  searchBar: {
    placeholder: 'เลือกโครงการ',
  },
  accountPopover: {
    home: 'หน้าแรก',
    setting: 'ตั้งค่า',
  },
  notificationPopover: {
    title: 'การแจ้งเตือน',
    description: 'คุณมี %{smart_count} ข้อความที่ยังไม่ได้อ่าน',
    viewAll: 'แสดงทั้งหมด',
  },
}
